"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _index = require("../index.styles");
var VizualizerErrorMessage = function VizualizerErrorMessage(_ref) {
  var isMobile = _ref.isMobile,
    onBackupImgClick = _ref.onBackupImgClick,
    backupImage = _ref.backupImage;
  return /*#__PURE__*/_react["default"].createElement(_index.ImageNotFoundWrapper, {
    isMobile: isMobile,
    onClick: onBackupImgClick
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: isMobile ? '' : 'center-backup-img'
  }, "Image Not Available"), /*#__PURE__*/_react["default"].createElement("img", {
    className: isMobile ? '' : 'center-backup-img',
    src: backupImage,
    alt: "Line Item Thumbnail"
  }));
};
VizualizerErrorMessage.propTypes = {
  isMobile: _propTypes["default"].bool,
  backupImage: _propTypes["default"].string,
  onBackupImgClick: _propTypes["default"].func
};
VizualizerErrorMessage.defaultProps = {
  isMobile: false,
  backupImage: undefined,
  onBackupImgClick: _noop["default"]
};
var _default = VizualizerErrorMessage;
exports["default"] = _default;
//# sourceMappingURL=index.js.map